"use client";

import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";

import Header from "@/components/header";

function Form() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal("ui", {
        theme: "light",
        styles: { branding: { brandColor: "#9b1b9c" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);
  return (
    <Cal
      calLink="cm-derek/demo"
      className="h-full w-full"
      config={{ layout: "month_view" }}
    />
  );
}

export default function ContactPage() {
  return (
    <div className="flex min-h-screen flex-grow items-center justify-center bg-gradient-to-t from-gray-200 to-purple-200 md:pt-10">
      <Header />
      <Form />
    </div>
  );
}
